<template>
  <div>
    <div
      :class="{ 'custom-error-border': validator && validator.$error}"
    >
      <div
        v-if="uploadInProgress"
        class="avatar-container"
      >
        <v-layout wrap justify-center style="width: 100%" fill-height align-center>
          <v-flex shrink>
            <v-progress-circular color="primary" indeterminate :size="75" />
          </v-flex>
        </v-layout>
      </div>
      <div v-else>
        <drop @drop="handleDrop">
          <div class="avatar-container text-center p-2">
            <div v-if="!value" class="avatar-placeholder">
              <v-layout justify-center column style="width: 100%">
                <v-flex style="margin-bottom: 2px" shrink>
                  <v-btn
                    color="primary"
                    icon
                    class="ml-0"
                    @click="openFSPicker"
                  >
                    <v-icon>photo_library</v-icon>
                  </v-btn>
                  <v-btn
                    color="primary"
                    icon
                    class="ml-0"
                    @click.stop="isCameraOpen = true"
                  >
                    <v-icon>photo_camera</v-icon>
                  </v-btn>
                </v-flex>
                <v-flex style="margin-bottom: 4px" shrink class="action-text">{{ adminText(&quot;shellAll.add_or_drop_attendee_image&quot;, &quot;Add or drop attendee image&quot;) }}</v-flex>
                <v-flex class="action-description" shrink>
                  {{ adminText(&quot;shellAll.image_with_4_5_aspect_ratio_and_no_larger_than_1_mb_recommended&quot;, &quot;Image with 4:5 aspect ratio and no larger than 1 MB recommended.&quot;) }}
                </v-flex>
              </v-layout>
            </div>
            <v-layout
              v-else
              class="avatar-image"
              justify-start
              align-end
              row
              :style="{ backgroundImage: 'url(' + value + ')'}"
            >
              <v-flex class="actions-container" shrink>
                <v-btn
                  icon
                  class="size-32 ml-0 mb-0 error"
                  @click.stop="removeImage"
                >
                  <v-icon>delete</v-icon>
                </v-btn>
              </v-flex>
            </v-layout>
          </div>
        </drop>
      </div>
    </div>
    <div
      style="text-align:center"
      :class="['custom-error-message', 'text-align', {'error--text': validator && validator.$error}]"
    >
      <span> {{ getErrors(validator)[0] }} &nbsp;</span>
    </div>
    <camera-dialog v-if="isCameraOpen" :open.sync="isCameraOpen" @image="uploadAvatar($event)" />
    <cropper-dialog
      :aspect-ratio="0.8"
      :image="dataURLImage"
      @dismissed="removeImage"
      @cropped="uploadAvatar($event)"
    />
    <hidden-file-input ref="file-input" max-file-size-mb="1" @file="processFile($event)" />
  </div>
</template>

<script>
import AdminContext from '@/admin-i18n/context'

import CameraDialog from './../../shared/dialogs/camera-dialog'
import HiddenFileInput from './../../shared/hidden-file-input'
import CropperDialog from './../../shared/dialogs/cropper-dialog'
import { fileToDataUrl, getUploadOptions, uploadImage, defaultMessages, getValidationErrors } from '@/utils'
import { UploadPaths } from '@/types'
import Vue from 'vue'

export default {
  mixins: [AdminContext],
  name: 'avatar-field',
  components: {
    CameraDialog,
    HiddenFileInput,
    CropperDialog,
  },
  props: {
    validator: {
      type: Object,
      default: null,
    },
    uploadOptions: {
      type: Object,
      default: () => ({}),
    },
    errorMessages: {
      type: Object,
      default: null,
    },
    value: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      isCameraOpen: false,
      dataURLImage: null,
      uploadInProgress: false,
    }
  },
  methods: {
    removeImage() {
      this.dataURLImage = null
      this.$emit('input', null)
      this.validator && this.validator.$touch()
    },
    handleDrop(data, event) {
      event.preventDefault()
      const { dataTransfer: { files } } = event
      this.processFile(files[0])
    },
    async processFile(file) {
      if(this.dataURLImage) {
        this.removeImage()
      }
      this.dataURLImage = await fileToDataUrl(file)
    },
    getErrors: function(field){
      return getValidationErrors({
        ...this.adminValidationMessages(defaultMessages),
        ...this.adminFieldValidationMessages(this.errorMessages),
      })(field)
    },
    async uploadAvatar(dataURL) {
      this.uploadInProgress = true
      const uploadPath = this.uploadOptions && this.uploadOptions.path? this.uploadOptions.path : UploadPaths.UNGROUPED
      const { file, path } = await getUploadOptions(dataURL, uploadPath, { width: 192, height: 241 })
      const url = await uploadImage(file, path)
      this.$emit('input', url)
      this.uploadInProgress = false
      this.validator && this.validator.$touch()
    },
  },
}
</script>

<style scoped>
  .avatar-container {
    position: relative;
    padding: 0;
    height: 241px;
    width: 192px;
  }

  .avatar-image::after {
    content: '';
    position: absolute;
    top: 0px; /* ie setting */
    left: 0px; /* ie setting */
    height: 100%;
    border-radius: 8px;
    background: rgba(33, 33, 33, .43);
}

  .avatar-placeholder {
    height: 100%;
    display: flex;
    border-radius: 8px;
    color: #979797;
    background-color: #f5f5f5;
    cursor: pointer;
    padding:12px;
  }
  .avatar-image {
    height: 100%;
    background-size: contain;
    width: 100%;
    display: flex;
    border-radius: 8px;
  }

  .avatar-placeholder:hover {
    background-color: rgba(2, 119, 189, 0.2);
  }
  .actions-container {
    padding: 12px;
    z-index: 2;
  }

</style>
